/*
  THAANI UI: Box zusammenstellen (sections/thaani-ui-box.liquid).

  Haelt die gewaehlten Sorten in der Reihenfolge, in der sie dazukommen,
  rechnet 5 + 1 und 10 + 3 gratis (die goldenen Felder, bezahlt werden die
  teuersten Sorten), stempelt jede Sorte als Etikett auf die Karte, feiert
  jedes erreichte goldene Feld und legt die Box als Positionen je Sorte in
  den Warenkorb. Die Auswahl merkt sich der Browser, damit sie nach
  einem Blick auf eine Produktseite noch da ist. Gratis im Checkout wird es
  erst mit einem passenden Shopify-Rabatt.
*/

if (!customElements.get('thaani-ui-box')) {
  customElements.define(
    'thaani-ui-box',
    class ThaaniUiBox extends HTMLElement {
      connectedCallback() {
        this.jede = Number(this.dataset.jede) || 6;
        this.max = Number(this.dataset.max) || 13;
        // Goldene Felder: bei 5 + 1 das sechste, bei 10 + 3 dazu das 12. und 13.
        this.gratisFelder = (this.dataset.gratisFelder || '')
          .split(',')
          .map(Number)
          .filter((feld) => feld > 0 && feld <= this.max);
        this.kaufbar = this.dataset.kaufbar === 'true';
        this.threshold = Number(this.dataset.threshold) || 0;
        this.cartTotal = Number(this.dataset.cartTotal) || 0;
        this.formatter = new Intl.NumberFormat(this.dataset.locale || 'de-CH', {
          style: 'currency',
          currency: this.dataset.currency || 'CHF',
        });
        this.sorten = [...this.querySelectorAll('[data-box-sorte]')];
        this.felder = [...this.querySelectorAll('[data-box-feld]')];
        this.karte = this.querySelector('.ui-box__stempel');
        this.liste = [];
        this.neuIndex = -1;
        this.welleB = false;
        this.laden();

        // Ebene fuer «Gratis erreicht»: haengt am body, damit sie ueber Kopf
        // und Leiste liegt. Ein Klick oder Esc schliesst sie.
        this.feier = this.feier || this.querySelector('[data-box-feier]');
        if (this.feier) {
          if (!this.feierBild) {
            this.feierBild = document.createElement('img');
            this.feierBild.alt = '';
            this.feierBild.decoding = 'async';
            this.feier.querySelector('[data-box-feier-glas]').prepend(this.feierBild);
          }
          document.body.append(this.feier);
          this.onFeierKlick = () => this.feierSchliessen();
          this.onFeierTaste = (event) => {
            if (event.key === 'Escape') this.feierSchliessen();
          };
          this.feier.addEventListener('click', this.onFeierKlick);
          document.addEventListener('keydown', this.onFeierTaste);
        }

        this.onClick = (event) => {
          const knopf = event.target.closest('[data-box-dazu], [data-box-weg]');
          if (knopf) {
            const id = knopf.closest('[data-box-sorte]').dataset.boxSorte;
            let goldenesFeld = 0;
            if (knopf.hasAttribute('data-box-dazu')) {
              if (this.liste.length < this.max) {
                this.liste.push(id);
                // Fuer die Welle: dieses Feld springt am Ende auf
                this.neuIndex = this.liste.length - 1;
                if (this.gratisFelder.includes(this.liste.length)) goldenesFeld = this.liste.length;
              }
            } else {
              const i = this.liste.lastIndexOf(id);
              if (i >= 0) this.liste.splice(i, 1);
              // Beim Herausnehmen keine Welle, nachrueckende Etiketten bleiben still
              this.karte?.classList.remove('is-welle-a', 'is-welle-b');
              this.feierSchliessen();
            }
            this.speichern();
            this.sync();
            if (goldenesFeld) this.feiern(goldenesFeld);
            return;
          }
          if (event.target.closest('[data-box-cta]')) this.inDenWarenkorb();
        };
        this.addEventListener('click', this.onClick);

        // Versandhinweis rechnet mit dem Warenkorb; nach dem Hinzufuegen nachziehen.
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            const total = event?.cartData?.total_price;
            if (typeof total === 'number') {
              this.cartTotal = total;
              this.sync();
            }
          });
        }
        this.sync();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.unsubscribe?.();
        if (this.feier) {
          this.feierSchliessen();
          this.feier.removeEventListener('click', this.onFeierKlick);
          document.removeEventListener('keydown', this.onFeierTaste);
          this.feier.remove();
        }
      }

      money(cents) {
        return this.formatter.format(Math.round(cents) / 100);
      }

      sorte(id) {
        return this.sorten.find((sorte) => sorte.dataset.boxSorte === id);
      }

      menge(id) {
        return this.liste.filter((eintrag) => eintrag === id).length;
      }

      // Gemerkte Auswahl, nur Sorten, die es auf der Seite noch gibt.
      // Frueher als { Varianten-ID: Menge } gespeichert, das wird umgewandelt.
      laden() {
        try {
          const roh = JSON.parse(localStorage.getItem('thaani-box') || '[]');
          const ids = Array.isArray(roh)
            ? roh.map(String)
            : Object.entries(roh).flatMap(([id, wert]) => Array(Math.max(0, Math.floor(Number(wert) || 0))).fill(id));
          this.liste = ids.filter((id) => this.sorte(id)).slice(0, this.max);
        } catch (error) {
          // Ohne Speicher startet die Box leer.
          this.liste = [];
        }
      }

      speichern() {
        try {
          localStorage.setItem('thaani-box', JSON.stringify(this.liste));
        } catch (error) {
          // Privates Fenster: die Auswahl gilt nur bis zum Neuladen.
        }
      }

      // So viele Sorten gratis, wie goldene Felder belegt sind: die guenstigsten im Paket
      rechnung(liste = this.liste) {
        const preise = liste.map((id) => Number(this.sorte(id)?.dataset.preis) || 0).sort((a, b) => b - a);
        const n = preise.length;
        const gratis = this.gratisFelder.filter((feld) => feld <= n).length;
        const regulaer = preise.reduce((summe, preis) => summe + preis, 0);
        const geschenkt = gratis > 0 ? preise.slice(n - gratis).reduce((summe, preis) => summe + preis, 0) : 0;
        return { n, gratis, geschenkt, total: regulaer - geschenkt };
      }

      // Neue Sorte (Canvas «Box: 12 Animationen», Nr. 11 «Welle», Chris 24.10.):
      // alle Etiketten nicken nacheinander, das neue springt am Ende auf. a und b
      // wechseln sich ab, damit die Welle jedes Mal von vorn beginnt. Die
      // Bewegung selbst steht in assets/thaani-ui-box.css.
      welle() {
        if (!this.karte) return;
        this.welleB = !this.welleB;
        this.karte.classList.toggle('is-welle-a', !this.welleB);
        this.karte.classList.toggle('is-welle-b', this.welleB);
      }

      // Gratis erreicht (Canvas «Box: 12 Animationen», Chris 24.10.): bei 5 + 1
      // landet das geschenkte Glas auf einem Sockel im Lichtkegel (Gratis 8.3),
      // bei 10 + 3 waechst es aus dem goldenen Feld und kehrt dorthin zurueck
      // (Gratis 8.4). Gezeigt wird die Sorte, deren Preis gerade geschenkt wird,
      // bei gleichem Preis die zuletzt dazugelegte. Die Bewegung selbst steht in
      // assets/thaani-ui-box.css; bei reduzierter Bewegung bleibt die Ebene zu.
      feiern(feld) {
        if (!this.feier || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const jetzt = this.rechnung();
        const betrag = jetzt.geschenkt - this.rechnung(this.liste.slice(0, -1)).geschenkt;
        const preis = (id) => Number(this.sorte(id)?.dataset.preis) || 0;
        const id = [...this.liste].reverse().find((eintrag) => preis(eintrag) === betrag) || this.liste[this.liste.length - 1];
        const sorte = this.sorte(id);
        const bild = sorte?.querySelector('.ui-box__etikett img');
        const quelle = bild?.currentSrc || bild?.src;
        if (!quelle) return;
        // Den ganzen Packshot gross, nicht den Etikett-Ausschnitt
        const url = new URL(quelle, window.location.href);
        url.searchParams.set('width', '800');
        this.feierBild.src = url.href;
        this.feier.style.setProperty('--bild', `url("${url.href}")`);

        const texte = this.dataset;
        const titel = [texte.textFeierEins, texte.textFeierZwei, texte.textFeierDrei][jetzt.gratis - 1] || texte.textFeierEins;
        const name = sorte.querySelector('.ui-box__name')?.textContent.trim() || '';
        this.feier.querySelector('[data-box-feier-titel]').textContent = titel;
        this.feier.querySelector('[data-box-feier-unter]').textContent = (texte.textFeierUnter || '')
          .replace('[sorte]', name)
          .replace('[betrag]', this.money(betrag));

        // Erst wenn die Welle das goldene Feld erreicht hat
        const art = feld === this.gratisFelder[0] ? 'sockel' : 'feld';
        clearTimeout(this.feierStart);
        this.feierStart = setTimeout(() => this.feierZeigen(art, this.felder[feld - 1]), 600);
      }

      feierZeigen(art, feld) {
        const ebene = this.feier;
        ebene.classList.remove('is-sockel', 'is-feld');
        ebene.hidden = false;
        if (art === 'feld' && feld) {
          // Weg zwischen goldenem Feld und Mitte. Liegt das Feld ausserhalb des
          // Bildschirms, kommt das Glas vom Rand und kehrt dorthin zurueck.
          const glas = ebene.querySelector('[data-box-feier-glas]');
          const ziel = feld.getBoundingClientRect();
          const x = Math.min(window.innerWidth, Math.max(0, ziel.left + ziel.width / 2));
          const y = Math.min(window.innerHeight + 80, Math.max(-80, ziel.top + ziel.height / 2));
          ebene.style.setProperty('--jx', `${Math.round(x - (glas.offsetLeft + glas.offsetWidth / 2))}px`);
          ebene.style.setProperty('--jy', `${Math.round(y - (glas.offsetTop + glas.offsetHeight / 2))}px`);
          ebene.style.setProperty('--js', Math.max(0.12, Math.min(0.4, ziel.width / glas.offsetWidth)).toFixed(3));
        }
        // Klasse neu setzen, damit die Animation auch ein zweites Mal startet
        void ebene.offsetWidth;
        ebene.classList.add(art === 'feld' ? 'is-feld' : 'is-sockel');
        clearTimeout(this.feierEnde);
        this.feierEnde = setTimeout(() => this.feierSchliessen(), 5200);
      }

      feierSchliessen() {
        clearTimeout(this.feierStart);
        clearTimeout(this.feierEnde);
        if (!this.feier) return;
        this.feier.hidden = true;
        this.feier.classList.remove('is-sockel', 'is-feld');
      }

      // Was als Naechstes gratis wird: erst die bezahlten Sorten bis zum
      // naechsten goldenen Feld, dann die goldenen Felder selbst
      hinweis(r) {
        const texte = this.dataset;
        if (r.n >= this.max) return texte.textVoll;
        const naechstes = this.gratisFelder.find((feld) => feld > r.n) || this.max;
        const bezahlt = naechstes - r.n - 1;
        if (r.gratis === 0) return bezahlt > 0 ? texte.textErste.replace('[anzahl]', bezahlt) : texte.textNaechsteEine;
        if (r.gratis === 1) return bezahlt > 0 ? texte.textZweite.replace('[anzahl]', bezahlt) : texte.textNaechsteZwei;
        return texte.textLetzte;
      }

      sync() {
        const r = this.rechnung();
        const texte = this.dataset;

        this.sorten.forEach((sorte) => {
          const menge = this.menge(sorte.dataset.boxSorte);
          sorte.classList.toggle('is-drin', menge > 0);
          sorte.querySelector('[data-box-anzahl]').textContent = menge;
          sorte.querySelector('[data-box-weg]').disabled = menge === 0;
          const dazu = sorte.querySelector('[data-box-dazu]');
          if (!dazu.hasAttribute('data-box-aus')) dazu.disabled = r.n >= this.max;
        });

        // Stempel in der Reihenfolge, in der die Sorten dazukamen. is-neu
        // wechselt nur mit einer neuen Sorte, sonst nickte das letzte Etikett
        // bei jedem Nachziehen (etwa nach einem Warenkorb-Update) noch einmal.
        this.felder.forEach((feld, i) => {
          const id = this.liste[i] || '';
          feld.classList.toggle('is-voll', id !== '');
          if (this.neuIndex >= 0) feld.classList.toggle('is-neu', i === this.neuIndex);
          if (feld.dataset.id === id) return;
          feld.dataset.id = id;
          feld.querySelector('.ui-box__etikett')?.remove();
          const etikett = id ? this.sorte(id)?.querySelector('.ui-box__etikett') : null;
          if (etikett) feld.prepend(etikett.cloneNode(true));
        });
        if (this.neuIndex >= 0) this.welle();
        this.neuIndex = -1;
        this.querySelectorAll('[data-box-marke]').forEach((marke) => {
          marke.classList.toggle('is-erreicht', r.n >= Number(marke.dataset.boxMarke));
        });

        const zahl = this.querySelector('[data-box-zahl]');
        if (zahl) zahl.textContent = r.n;
        // Zaehler am Box-Symbol im Kopf (Handy) gleich mitziehen
        document.querySelectorAll('[data-box-zahl-kopf]').forEach((kopf) => {
          kopf.textContent = r.n;
          kopf.hidden = r.n === 0;
        });
        const stueck = texte.textStueck.replace('[anzahl]', r.n).replace('[gratis]', r.gratis);
        const zaehler = this.querySelector('[data-box-zaehler]');
        if (zaehler) zaehler.textContent = stueck;
        const hinweis = this.querySelector('[data-box-hinweis]');
        if (hinweis) hinweis.textContent = this.hinweis(r);
        const spar = this.querySelector('[data-box-spar]');
        if (spar) {
          spar.hidden = r.geschenkt === 0;
          spar.textContent = (texte.textSpar || '').replace('[betrag]', this.money(r.geschenkt));
        }

        const summe = this.querySelector('[data-box-summe]');
        if (summe) summe.textContent = this.money(r.total);
        const stand = this.querySelector('[data-box-stand]');
        if (stand) {
          const fehlt = this.threshold - this.cartTotal - r.total;
          const versand = !this.threshold ? '' : fehlt <= 0 ? texte.textVersandErreicht : texte.textVersandFehlt.replace('[betrag]', this.money(fehlt));
          stand.textContent = [stueck, versand].filter(Boolean).join(' · ');
        }

        // Vor dem Verkaufsstart bleibt der Button bei «Bald erhaeltlich».
        const cta = this.querySelector('[data-box-cta]');
        if (cta && this.kaufbar) {
          const genug = r.n >= this.jede;
          cta.disabled = !genug;
          cta.textContent = genug
            ? `${texte.textCta}${texte.ctaSeparator || ' – '}${this.money(r.total)}`
            : texte.textAb.replace('[jede]', this.jede).replace('[anzahl]', this.jede - r.n);
        }
      }

      // Wie die Kaufkarte beim Mix (assets/thaani-ui-buybox.js): eine
      // Position je Sorte, danach die Warenkorb-Schublade neu zeichnen.
      async inDenWarenkorb() {
        const cta = this.querySelector('[data-box-cta]');
        const fehler = this.querySelector('[data-box-fehler]');
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const mengen = new Map();
        this.liste.forEach((id) => mengen.set(id, (mengen.get(id) || 0) + 1));
        const items = [...mengen].map(([id, quantity]) => ({ id: Number(id), quantity }));
        if (!items.length || !this.kaufbar || cta?.getAttribute('aria-disabled') === 'true') return;
        cta?.setAttribute('aria-disabled', 'true');
        if (fehler) fehler.hidden = true;

        const body = { items };
        if (cart) {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          cart.setActiveElement?.(document.activeElement);
        }

        try {
          const response = await fetch(window.routes.cart_add_url, { ...fetchConfig('javascript'), body: JSON.stringify(body) });
          const data = await response.json();
          if (data.status) {
            if (fehler) {
              fehler.textContent = data.description || data.message || '';
              fehler.hidden = false;
            }
            return;
          }
          this.liste = [];
          this.speichern();
          this.sync();
          if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'thaani-ui-box', productVariantId: items[0].id, cartData: data });
          }
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        } catch (error) {
          console.error(error);
          if (fehler) {
            fehler.textContent = window.cartStrings?.error || '';
            fehler.hidden = false;
          }
        } finally {
          cta?.removeAttribute('aria-disabled');
        }
      }
    }
  );
}
